import {TradeSimulationService} from "./TradeSimulationService";
import {LocalStorageService} from "../../types/NgStorage";
import {Expiries} from "../../services/expiry/Expiries";
import {TradeSimulatorViewStore} from "./TradeSimulatorViewStore";
import {HistoricalPriceService} from "../../services/price/historical/HistoricalPriceService";

export class TradeSimulatorViewStoreFactory {

    public static id = "tradeSimulatorViewStoreFactory";

    /** @ngInject */
    public constructor(private tradeSimulationService: TradeSimulationService,
                       private $localStorage: LocalStorageService,
                       private historicalPriceService: HistoricalPriceService) {
    }

    public create(expiries: Expiries,
                  holidays: Array<Date>): TradeSimulatorViewStore {
        return TradeSimulatorViewStore.initialize(expiries,
                                                  holidays,
                                                  this.$localStorage,
                                                  this.tradeSimulationService,
                                                  this.historicalPriceService);
    }
}
